import { Component, EventEmitter, Output, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-export',
    templateUrl: './csat-privacy.component.html',
    styleUrls: ['./csat-privacy.component.scss'],
    standalone: false
})
export class CsatPrivacyComponent {
    private readonly modalRef = inject(BsModalRef);

    @Output() public confirm = new EventEmitter();
    @Output() public scrolled = new EventEmitter();

    public onScroll(): void {
        this.scrolled.emit();
    }

    public dismissModal(): void {
        this.modalRef.hide();
    }
}
